<template>
  <div style="background-color: white; min-height: 100vh; overflow-y: auto">
    <div class="vg-content">
      <van-image class="logo" width="100" height="50" :src="srcLogo"/>
      <div class="entry">
        <span class="title">项目</span>
        <van-field class="text" v-model="strProject.projectName" placeholder="请选择项目" @click="chooseProject" readonly
                   is-link center/>
      </div>
      <div class="entry">
        <span class="title">计费科目</span>
        <van-field class="text" v-model="strSubject.billingAccountName" placeholder="请选择计费科目" @click="chooseSubject"
                   readonly is-link center/>
      </div>
      <div class="entry" v-if="subSubjectList.length>0">
        <span class="title">子计费科目</span>
        <van-field class="text" v-model="strSubSubject.childBillingAccountName" placeholder="请选择子计费科目"
                   @click="chooseSubSubject" readonly is-link center/>
      </div>
      <div class="entry">
        <span class="title">支付金额</span>
        <van-field class="text" v-model="strPrice" type="number" :formatter="formatter"
                   format-trigger="onBlur" placeholder="请输入支付金额，支持2位小数点" :border="false" center/>
        <div v-if="paymentUpperLimit" class="hint">{{ paymentUpperLimitStr }}</div>
      </div>
      <div class="entry">
        <span class="title">备注</span>
        <van-field class="text" type="textarea" v-model="strRemarks" show-word-limit
                   placeholder="请输入收款事由" rows="2" autosize center maxlength="50"/>
      </div>
    </div>
    <vg-button-group>
      <vg-button type="primary" @click="onSubmit">发起收费</vg-button>
    </vg-button-group>
  </div>
</template>

<script>
import {Image as VanImage, Field, Toast} from 'vant';
import VgButton from "@/components/Commons/VgButton";
import VgButtonGroup from "@/components/Commons/VgButtonGroupFixed.vue";
import srcLogo from "@/assets/login/kaidelogo.png";
import {client} from "@/libraries/http";
import eventBus from '@/router/eventBus';
import useProjectStore from "@/store/project";
//import useSubProjectStore from "@/store/subProject";
import useformStore from "@/store/sporadicChargeform";
import {mapState} from "pinia";
import chargeProjectStore from "@/store/chargeProject";

export default {
  name: "SporadicCharges",
  components: {
    VanImage, "van-field": Field, VgButton, VgButtonGroup,
  },
  data() {
    return {
      srcLogo: srcLogo,
      strProject: {},
      strSubject: {},
      strSubSubject: {},
      strPrice: "",
      strRemarks: "",
      paymentUpperLimit: undefined,
      projectList: [],
      subjectList: [],
      subSubjectList: [],
      paymentUpperLimitStr: ""
    }
  },
  watch: {

    'strRemarks': function (newVal, oldVal) {
      if (newVal < 0) {
        this.$toast('输入金额不能为负数！');
        this.parems.paymoney = '';
      }
      // 解决数字键盘可以输入输入多个小数点问题
      if (newVal === '' && oldVal.toString().indexOf('.') > 0) {
        this.parems.paymoney = oldVal;
        return;
      }
      // 保留两位小数
      if (newVal) {
        newVal = newVal.toString();
        var pointIndex = newVal.indexOf('.');
        if (pointIndex > 0 && (newVal.length - pointIndex) > 3) {
          this.parems.paymoney = oldVal;
          return;
        }
      }
      // 最大值
      if (newVal > 9999999999) {
        this.parems.paymoney = oldVal;
        this.$toast('输入数值太大！');
        return;
      }
    }
  },
  created() {
    this.getProjectList();
    // this.getLimit();
    const useform = useformStore();
    if (useform?.form?.strProject) {
      this.strProject = useform?.form?.strProject;
    }
    if (useform?.form?.strSubject) {
      this.strSubject = useform?.form?.strSubject;
      this.getLimitPrice(useform?.form?.strSubject.id.value);
    }
    if (useform?.form?.strSubSubject) {
      this.strSubSubject = useform?.form?.strSubSubject;
    }
    if (useform?.form?.strPrice) {
      this.strPrice = useform?.form?.strPrice;
    }
    if (useform?.form?.strRemarks) {
      this.strRemarks = useform?.form?.strRemarks;
    }
    if (useform?.form?.paymentUpperLimit) {
      this.paymentUpperLimit = useform?.form?.paymentUpperLimit;
    }

  },
  computed: {
    ...mapState(useformStore, ['form']),
    ...mapState(chargeProjectStore, ['chargeProject']),
  },
  methods: {
    formatter(val) {
      if (!val) {
        return "";
      }
      if(/(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(val)){
        if (Number(val) > this.paymentUpperLimit) {
          Toast('支付金额已超过上限金额，请重新输入')
          return val;
        }
        return val;
      }
      // Math.abs返回数的绝对值
      let sign = val == (val = Math.abs(val));
      // Math.floor向下取整
      val = Math.floor(val * 100 + 0.50000000001);
      let cents = val % 100;
      val = Math.floor(val / 100).toString();
      if (cents < 10) {
        cents = "0" + cents;
      }
      if (Number(val + "." + cents) > this.paymentUpperLimit) {
        Toast('支付金额已超过上限金额，请重新输入')
        return;
      }
      return (sign ? "" : "-") + val + "." + cents;
    },
    getLimit() {
      client.get('/api/h5/guard/sporadic-billing-account-setting/getLimit').then(rsp => {
        this.paymentUpperLimit = rsp.data.paymentUpperLimit;
        this.paymentUpperLimitStr = rsp.data.paymentUpperLimit !== '99999999' ? "注：上限金额" + rsp.data.paymentUpperLimit + "元" : "注：无上限金额";
      });
    },
    getProjectList: function () {
      const projectStore = useProjectStore();
      const formStore = useformStore();
      client.get('/api/h5/guard/projects-leo-list?projectId=' + projectStore.projectInfo.projectId).then(rsp => {
        const chargeProjectList = chargeProjectStore();
        chargeProjectList.setProjectList(rsp.data);
        chargeProjectList.setIsChangePro(false);
        this.projectList = rsp.data;
        if (!formStore?.form?.strProject) {
          if (this.projectList.length === 1) {
            this.strProject = this.projectList[0];
            this.getSubject(this.projectList[0].projectId);
            formStore.setForm(
                {
                  strProject: this.strProject,
                  strSubject: formStore?.form?.strSubject,
                  strSubSubject: formStore?.form?.strSubSubject,
                  strPrice: formStore?.form?.strPrice,
                  strRemarks: formStore?.form?.strRemarks,
                  paymentUpperLimit: formStore?.form?.paymentUpperLimit,
                }
            )
          }
        } else {
          this.strProject = formStore?.form?.strProject;
          this.strPrice = formStore?.form?.strPrice;
          this.strRemarks = formStore?.form?.strRemarks;
          this.paymentUpperLimit = formStore?.form?.paymentUpperLimit;
          this.getSubject(this.strProject.projectId);
        }
      });
    },
    getSubject(projectId) {
      client.get('/api/h5/guard/sporadic-billing-account-setting/list?projectId=' + projectId).then(rsp => {
        const chargeProjectList = chargeProjectStore();
        this.subjectList = rsp.data;
        chargeProjectList.setStrProjectList(rsp.data);
        const formStore = useformStore();
        if (!formStore?.form?.strSubject) {
          if (this.subjectList.length === 0) {
            this.strSubject = {};
            this.subjectList = [];
            this.subSubjectList = [];
            this.strSubSubject = {};
          }
          if (this.subjectList.length === 1) {
            this.strSubject = this.subjectList[0];
            chargeProjectList.setStrSubProjectList(this.subjectList[0].childBillingAccounts);
            this.subSubjectList = this.subjectList[0].childBillingAccounts;
            formStore.setForm(
                {
                  strProject: formStore?.form?.strProject,
                  strSubject: this.strSubject,
                  strSubSubject: formStore?.form?.strSubSubject,
                  strPrice: formStore?.form?.strPrice,
                  strRemarks: formStore?.form?.strRemarks,
                  paymentUpperLimit: formStore?.form?.paymentUpperLimit,
                }
            )
          }
        } else {
          this.strSubject = formStore?.form?.strSubject;
          this.strProject = formStore?.form?.strProject;
          this.strPrice = formStore?.form?.strPrice;
          this.strRemarks = formStore?.form?.strRemarks;
          chargeProjectList.setStrSubProjectList(this.strSubject.childBillingAccounts);
          this.subSubjectList = this.strSubject.childBillingAccounts;
          if (formStore?.form?.strSubSubject) {
            this.strSubSubject = formStore?.form?.strSubSubject;
            this.strProject = formStore?.form?.strProject;
            this.strPrice = formStore?.form?.strPrice;
            this.strRemarks = formStore?.form?.strRemarks;
          }
          if (this.subSubjectList.length === 1) {
            this.strSubSubject = this.strSubject.childBillingAccounts[0];
            console.log(this.strSubSubject)
            formStore.setForm(
                {
                  strProject: formStore?.form?.strProject,
                  strSubject: formStore?.form?.strSubject,
                  strSubSubject: formStore?.form?.strSubSubject,
                  strPrice: formStore?.form?.strPrice,
                  strRemarks: formStore?.form?.strRemarks,
                  paymentUpperLimit: formStore?.form?.paymentUpperLimit,
                }
            )
          }
        }
      });
    },
    chooseProject() {
      if (this.projectList.length === 1) {
        return;
      }
      const formStore = useformStore();
      formStore.setForm(
          {
            strProject: formStore?.form?.strProject,
            strSubject: formStore?.form?.strSubject,
            strSubSubject: formStore?.form?.strSubSubject,
            strPrice: this.strPrice,
            strRemarks: this.strRemarks,
            paymentUpperLimit: this.paymentUpperLimit,
          }
      )
      this.$router.push({
        name: 'choiceProject',
      });
    },

    chooseSubject() {
      if (this.subjectList.length === 1 || this.subjectList.length === 0) {
        return;
      }
      const formStore = useformStore();
      formStore.setForm(
          {
            strProject: formStore?.form?.strProject,
            strSubject: formStore?.form?.strSubject,
            strSubSubject: formStore?.form?.strSubSubject,
            strPrice: this.strPrice,
            strRemarks: this.strRemarks,
            paymentUpperLimit: this.paymentUpperLimit,
          }
      )
      this.$router.push({
        name: 'choiceSubject',
      });
    },
    chooseSubSubject() {
      if (this.subSubjectList.length === 1 || this.subSubjectList.length === 0) {
        return;
      }
      const formStore = useformStore();
      formStore.setForm(
          {
            strProject: formStore?.form?.strProject,
            strSubject: formStore?.form?.strSubject,
            strSubSubject: formStore?.form?.strSubSubject,
            strPrice: this.strPrice,
            strRemarks: this.strRemarks,
            paymentUpperLimit: this.paymentUpperLimit,
          }
      )
      this.$router.push({
        name: 'choiceSubSubject',
      });
    },
    onSubmit() {
      if (!this.strProject.projectName) {
        Toast('请选择项目')
        return;
      }
      if (!this.strSubject.billingAccountName) {
        Toast('请选择计费科目')
        return;
      }
      if(this.subSubjectList.length > 0 && !this.strSubSubject.childBillingAccountName){
        Toast('请选择子计费项目')
        return;
      }
      if (!this.strPrice) {
        Toast('请填写支付金额')
        return;
      }
      if (!this.formatter(this.strPrice)) {
        return;
      }
      let sporadicBillingRecord = {
        projectId: this.strProject.projectId,
        profitCenterId: this.strProject.profitCenterId,
        sporadicBillingAccountSettingId: this.strSubject.id.value,
        childBillingAccountId: this.strSubSubject?.id?.value,
        paymentAmount: this.strPrice,
        remarks: this.strRemarks
      }
      client.post('/api/h5/guard/sporadic-billing-record', sporadicBillingRecord).then(rsp => {
        if (rsp.status == 200) {
          this.$router.replace({
            path: '/scanVerify/chargeCode',
            query: {
              id: rsp.data.id.value,
              price: rsp.data.paymentAmount
            }
          });
        }
      });
    },
    getLimitPrice(id) {
      client.get('/api/h5/guard/billing-account/getLimitPrice?sporadicBillingAccountSettingId=' + id).then(rsp => {
        this.paymentUpperLimit = rsp.data;
        this.paymentUpperLimitStr = rsp.data != '99999999' ? "注：上限金额" + rsp.data + "元" : "注：无上限金额";
        const formStore = useformStore();
        formStore.setForm(
            {
              strProject: formStore?.form?.strProject,
              strSubject: formStore?.form?.strSubject,
              strSubSubject: formStore?.form?.strSubSubject,
              strPrice: formStore?.form?.strPrice,
              strRemarks: formStore?.form?.strRemarks,
              paymentUpperLimit: this.paymentUpperLimit,
            }
        )
      });
    },
  },
  beforeDestroy() {
    eventBus.$off('strProject');
    eventBus.$off('strSubject');
    eventBus.$off('strSubSubject');
  },
}
</script>

<style scoped>
.vg-content {
  margin: 15px;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  align-items: stretch;
}

.logo {
  align-self: flex-start;
}

.entry {
  margin: 15px 25px 0px;
  display: flex;
  flex-direction: column;

}

.title {
  margin-top: 15px;
  color: #101010;
  font-size: 14px;
}

.text {
  margin-top: 5px;
  padding-left: 0px;
  padding-right: 0px;
  min-height: 40px;
  color: #101010;
  font-size: 16px;
  border-bottom: 1px solid #E5E5EA;
}

.hint {
  margin-top: 5px;
  color: #B4B4B4;
  font-size: 14px;
}

.vg-content >>> .entry .van-cell::after {
  right: 0;
  left: 0;
  border-bottom: 1px solid #E5E5EA;
}

::v-deep .van-field__control::placeholder {
  color: #B4B4B4 !important;
}

::v-deep .van-field__control::-webkit-input-placeholder { /* 使用webkit内核的浏览器 */
  color: #B4B4B4 !important;
}

::v-deep .van-field__control:-moz-placeholder { /* Firefox版本4-18 */
  color: #B4B4B4 !important;
}

::v-deep .van-field__control::-moz-placeholder { /* Firefox版本19+ */
  color: #B4B4B4 !important;
}

::v-deep .van-field__control:-ms-input-placeholder { /* IE浏览器 */
  color: #B4B4B4 !important;
}


.item-arrow {
  margin-left: 15px;
  float: right;
  height: 20px;
  width: 20px;
  background-image: url("@/assets/right_arrow.svg");
}

</style>
